/**
 * Strip trailing slashes and mistaken **`/api`** or **`/api/v1`** suffixes so client paths like
 * **`/api/v1/...`** are not doubled (e.g. **`VITE_API_BASE_URL=http://host:3000/api/v1`**).
 */
function normalizeApiOrigin(raw: string): string {
  let t = raw.trim().replace(/\/+$/, "");
  if (t === "") return "";
  t = t.replace(/\/api\/v1$/i, "").replace(/\/api$/i, "").replace(/\/+$/, "");
  return t;
}

/**
 * Empty string = same-origin **`/api`** / **`/socket.io`** (Vite dev proxy). Set **`VITE_API_BASE_URL`**
 * only when the API is on another host and **`CORS_ORIGINS`** on the API includes this app’s origin (e.g. `http://localhost:5176`).
 */
export function getTransporterApiBaseUrl(): string {
  const v = import.meta.env.VITE_API_BASE_URL;
  if (typeof v === "string" && v.trim().length > 0) {
    return normalizeApiOrigin(v);
  }
  if (import.meta.env.DEV) {
    return "";
  }
  return "";
}
